const TRANSLATIONS = {
	noleggiatori: ['NOLEGGIATORI', 'RENTAL OPERATORS', 'AGENTES DE ALQUILER'],
	documentazione: ['DOCUMENTAZIONE', 'DOCUMENTATION', 'DOCUMENTACIÓN'],
};

function checkTemplatesPath(currentFolder, translations) {
	const pathSegments = currentFolder.prev_folders.map((f) => f.title);
	pathSegments.push(currentFolder.title);

	if (pathSegments.length < 4) {
		return { isTemplatesParent: false, isTemplatesFolder: false };
	}

	const [root, noleggiatori, documentazione, ...rest] = pathSegments;

	const isValidRoot = root === 'root';
	const isValidNoleggiatori = translations.noleggiatori.includes(noleggiatori);
	const isValidDocumentazione =
		translations.documentazione.includes(documentazione);

	if (!isValidRoot || !isValidNoleggiatori || !isValidDocumentazione) {
		return { isTemplatesParent: false, isTemplatesFolder: false };
	}

	const isTemplatesParent = pathSegments.length === 5;
	const isTemplatesFolder =
		pathSegments.length === 6 && pathSegments[5] === 'TEMPLATES';

	return { isTemplatesParent, isTemplatesFolder };
}

export function checkTemplatesFolder(currentFolder) {
	try {
		return checkTemplatesPath(currentFolder, TRANSLATIONS);
	} catch (error) {
		console.warn(error);
		return { isTemplatesParent: false, isTemplatesFolder: false };
	}
}
